import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Link as RouterLink } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import { useMutation } from "react-query";


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ListCards() {
  const formatPrice = (amount, currency)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

    const [cards, setcards] = useState(null);
    const { isLoading: isLoadingcards, refetch: getcards } = useQuery(
        "show-cards",
        async () => {
          return await apiClient.get("/api/show-cards");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setcards(res.data.cards);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getcards() 
        if (isLoadingcards) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

      const [open2, setOpen2] = React.useState(false);
      const [cardId, setcardId] = useState('');
      const [cardStatus, setcardStatus] = useState('');

      const handleClose2 = () => {
        setOpen2(false);
      };
      const handleToggle2 = () => {
        setOpen2(!open2);
      };


      const { isLoading: isUpdating, mutate: updatecard } = useMutation(
        async () => {
          return await apiClient.post(`/api/update-card`, {
            card_id: cardId,
            status: cardStatus,
          });
          
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
      
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                setTimeout(() => {
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
                }, 1000);
      
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
                handleClose2();
                getcards();
                
              }            
          },
          onError: (err) => {
            let errorMessage = err.response?.data || err ;
            localStorage.setItem('notification', JSON.stringify({message : `${errorMessage.message}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event4 = new Event('processed');
            window.dispatchEvent(event4);
            
          },
        }
      );


  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingcards ? 'Loading...' : 'List of cards'}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Button component={RouterLink} to="/card-activation-settings" variant="contained">
          Edit activation fee message
        </Button>
      </Box>
    <TableContainer component={Paper}>
        
      {cards !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>User Name</TableCell>
          <TableCell align="right">User Email</TableCell>
          <TableCell align="right">Card Number</TableCell>
          <TableCell align="right">Card Type</TableCell>          
          <TableCell align="right">Status</TableCell>
          <TableCell align="right">Fee Paid</TableCell>
          <TableCell align="right">Payment Method</TableCell>
          <TableCell align="right">Payment Ref</TableCell>
          <TableCell align="right">Proof</TableCell>
          <TableCell align="right">View</TableCell>
          <TableCell align="right">Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {cards.map((card) => (
          <TableRow
            key={card.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {card.user.name}
            </TableCell>
            <TableCell align="right">{card.user.email}</TableCell>
            <TableCell align="right">{`${card.number1} ${card.number2} ${card.number3} ${card.number4}`}</TableCell>
            <TableCell align="right">{card.card_type}</TableCell>
            <TableCell align="right">{card.status}</TableCell>
            <TableCell align="right">{card.payment_amount ? formatPrice(card.payment_amount) : '-'}</TableCell>
            <TableCell align="right">{card.payment_gateway || '-'}</TableCell>
            <TableCell align="right">{card.payment_reference || '-'}</TableCell>
            <TableCell align="right">
              {card.payment_proof ?
                <a href={card.payment_proof} target="_blank" rel="noreferrer">
                  {String(card.payment_proof).toLowerCase().includes('.pdf') ? 'View proof' : <img style={{height: '50px'}} src={card.payment_proof} alt="proof" />}
                </a>
              : '-'}
            </TableCell>
            <TableCell align="right"><Button
            onClick={() =>{handleToggle2(); setcardId(card.id); setcardStatus(card.status);}} 
             startIcon={<EditIcon />}>Edit card</Button></TableCell>
            <TableCell align="right">{getDate(card.created_at)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>

    <Dialog
        
        open={open2}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{textAlign: 'center'}}>{"UPDATE STATUS"}</DialogTitle>
        <DialogContent>
          <Box px={1} sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly'}}>

          {cards !== null && cards.filter(item => item.id === cardId).map(item => (
            item.payment_note ?
            <Typography key={`note-${item.id}`} variant="body2" sx={{ mb: 1 }}>
              Payment note: {item.payment_note}
            </Typography>
            : null
          ))}

          <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
            <InputLabel htmlFor="status">status</InputLabel>
                <Select
                    value={cardStatus}
                    onChange={(e) => setcardStatus(e.target.value)}
                    labelId="status"
                    id="status"
                    name="status"
                    label='status'
                    >
                    <MenuItem selected value=''>
                        select status
                    </MenuItem> 
                    <MenuItem value="pending">pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="activation_pending">Activation Pending</MenuItem>
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="completed">Completed</MenuItem>
                    <MenuItem value="declined">Declined</MenuItem>
                </Select>
            </FormControl>
          </Box>          
        </DialogContent>
        
        <DialogActions>
            <Button onClick={()=>updatecard()} color='error'>{isUpdating? 'Updating...': 'Update Status'}</Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}